// extracted by mini-css-extract-plugin
module.exports = {"footer":"MutateMid_footer__3uq9l","legacyBtn":"MutateMid_legacyBtn__3SLQE"};